export default "__VITE_ASSET__BX2amOAt__"